module.exports = __webpack_public_path__ + "static/media/builder-icon.4357ea89.svg";